<template>
  <div class="customerHotline" @click.stop>
    <div class="cusBtn" @click="open">
      <div>客户服务热线</div>
      <!-- <div>Customer Hotline</div> -->
      <div>技术支持：极酷物联</div>
    </div>

    <div class="cusCont" v-if="isShowCustomer==true">
      <!-- <div class="img"><img class="itImg" src="../../static/images/contact_title.png" alt=""></div>
      <div class="img"><img class="itImg2" src="../../static/images/contact_icon.png" alt=""></div> -->
      <div class="item"><span>客服电话：</span>{{hotlineInfo.hotline}}</div>
      <div class="item">服务时间：{{hotlineInfo.hotline_start_time}}~{{hotlineInfo.hotline_end_time}}</div>
      <div class="back" @click="back">返回</div>
    </div>
  </div>
</template>
<script>
import * as config from '../../static/js/config.js'
import { messageError } from '../../static/js/utils/utility'
import {commonApi} from '../../static/js/api'
let vm

export default {
  name:'currTime',
  props:{
    // isShowInfo:{
    //   type:Boolean,
    //   required: true
    // }
  },
  data(){
    return {
      isShowCustomer:false,
      
      hotlineInfo: {}
    }
  },
  created(){
    vm = this
    vm.getHotline()
  },
  methods:{
    // 获取客服热线信息
    async getHotline () {
      let data = {
        cabinet_id: config.deviceId
      }

      let res = await commonApi.getHotline(data)
      if (res.meta.code === 200) {
        vm.hotlineInfo = res.data
      } else {
        messageError(res.meta.message)
      }
    },
    //打开
    open(){
      this.isShowCustomer = true
    },
    //返回
    back(){
      this.isShowCustomer = false
    },
    
  },
  watch:{
    
  }
}
</script>
<style lang="less">
.customerHotline{
  .cusCont{
    position: fixed;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #f2f2f2;
    text-align: center;
    padding: 0.5rem;
    box-sizing: border-box;
    .img{
			margin: 0.2rem 0;
			.itImg{
				width: 3.02rem;
				height: 0.4rem;
			}
			.itImg2{
				width: 3.48rem;
				height: 1.3rem;
			}
		}
    .item{
      color: #666;
      font-size: 0.5rem;
      margin: 0.2rem 0;
      span{
        color: #409EFF;
      }
    }
    .back{
      position: absolute;
      left: 0;
      width: 100%;
      bottom: 0;
      height: 0.8rem;
      line-height: 0.8rem;
      background: #409EFF;
      color: #fff;
      font-size: 0.3rem;
    }
  }
  .cusBtn{
    padding: 0.2rem;
    background: #fff;
    color: #a67c32;
    font-size: 0.32rem;
    position: fixed;
    right: 0.4rem;
    bottom: 0.2rem;
    border-radius: 0.1rem;
    // box-shadow: 0 0.1rem 0.1rem 0.05rem rgba(0,0,0,.7)
  }
  
}
</style>




// WEBPACK FOOTER //
// src/assets/custService.vue